export const getSalePricePart = (value) => {
  if (value) {
    const match = value.match(/(\d+)\s*\/\s*(\d+)/);

    if (match) {
      const denominator = Number(match[1]);
      const numerator = Number(match[2]);

      return  numerator / denominator;
    } else return value
  } else return ''
};